import React, { useContext, useState } from "react";
import SideBar from "../SideBar";
import TabPanel from "../TabPanel";
import { contentData } from "../../assets/data/contentData";
import StartPage from "../../Pages/Content/StartPage";
import QuickLinks from "../../Pages/Content/QuickLinks/QuickLinks";
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import ThemeContext from "../../context/ThemeProvider";
import { useQuickLinksItems } from "../../context/QuickLinksContext";

import {
  RootWrapper,
  SidebarWrapper,
  ContentWrapper,
  DragOverlayBox,
  DragOverlayText,
} from "./CustomTab.styles";

const CustomTab = () => {
  const { selectedTheme } = useContext(ThemeContext);

  const {
    droppedItems,
    setDroppedItems,
    selectedTab,
    setSelectedTab,
    tabs,
    setTabs,
    primaryTabs,
    secondaryTabs,
  } = useQuickLinksItems();

  const [draggingItem, setDraggingItem] = useState(null);

  const handleDragStart = (event) => {
    setDraggingItem(event.active.id);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) {
      setDraggingItem(null);
      return;
    }

    if (over && over.id === "droppable") {
      setDroppedItems((prev) => {
        if (droppedItems?.length < 5 && !droppedItems.includes(active.id)) {
          return [...droppedItems, active.id];
        }
        return droppedItems;
      });
    }

    setDraggingItem(null);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  const isDefaultTheme = selectedTheme === "default";

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <RootWrapper>
        <SidebarWrapper>
          <SideBar
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
            data={tabs}
            setTabs={setTabs}
            primaryTabs={primaryTabs}
            secondaryTabs={secondaryTabs}
          />
        </SidebarWrapper>
        <ContentWrapper>
          {selectedTab === "home" ? (
            <StartPage
              droppedItems={droppedItems}
              setDroppedItems={setDroppedItems}
            />
          ) : selectedTab === "quickLinks" ? (
            <QuickLinks />
          ) : (
            tabs.map((tab, index) => (
              <TabPanel
                key={tab.id}
                selectedValue={selectedTab}
                value={tab.id}
                index={index}
              >
                {contentData[tab.id]}
              </TabPanel>
            ))
          )}
        </ContentWrapper>
      </RootWrapper>

      <DragOverlay>
        {draggingItem && (
          <DragOverlayBox isDefaultTheme={isDefaultTheme}>
            <DragOverlayText>{draggingItem}</DragOverlayText>
          </DragOverlayBox>
        )}
      </DragOverlay>
    </DndContext>
  );
};

export default CustomTab;
